import { render } from "./SpeechRecognizer.vue?vue&type=template&id=55562f75&scoped=true"
import script from "./SpeechRecognizer.vue?vue&type=script&lang=js"
export * from "./SpeechRecognizer.vue?vue&type=script&lang=js"

import "./SpeechRecognizer.vue?vue&type=style&index=0&id=55562f75&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55562f75"]])

export default __exports__